/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:39:04AM]
Permissions to update outside the main branch: [false]
*/

import { DesignType, DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { Dictionary } from 'lodash';
import {
    DictionaryAdd,
    DictionaryChange,
    DictionaryFilter,
    DictionaryTable,
} from 'models/api/dictionary';
import DictItem from 'models/api/dictItem';
import ResTable from 'models/api/table';
import { Key } from 'react';

export const getCultures = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DictItem[]>('/dictionary/cultures');
    return data;
};

export const getDesign = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown<DesignType>[]>('/dictionary/designs');
    return data;
};

export const getDictList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DictItem[]>('/dictionary/dicts');
    return data;
};

export const getDictionaryItems = async (axios: AxiosInstance, dictCode: string) => {
    const { data } = await axios.get<DictItem[]>(`/dictionary/items/${dictCode}`);
    return data;
};

export const getDictionaryItemsByCulture = async (axios: AxiosInstance, dictCode: string) => {
    const { data } = await axios.get<DictItem[]>(`/dictionary/items/${dictCode}`);
    return data;
};

export const getDictionary = async (axios: AxiosInstance, params?: DictionaryFilter) => {
    const { data } = await axios.get<
        ResTable<DictionaryTable> & {
            IsUserEditable: boolean;
        }
    >('/dictionary', { params });
    return data;
};

export const getDictionaryExcel = async (axios: AxiosInstance, params: DictionaryFilter) => {
    const { data } = await axios.get<Blob>('/dictionary/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addDictionaryItem = async (axios: AxiosInstance, item: DictionaryAdd) => {
    return await axios.post<undefined>('/dictionary', item);
};

export const changeDictionaryItem = async (axios: AxiosInstance, item: DictionaryChange) => {
    return await axios.put<undefined>(`/dictionary/${item.id}`, item);
};

export const deleteDictionaryItem = async (axios: AxiosInstance, id: string | number) => {
    return await axios.delete<undefined>(`/dictionary/${id}`);
};

export const getSelectList = async (
    axios: AxiosInstance,
    codes: string[],
    current?: string | null,
    filterByRoles?: boolean
) => {
    const responce = await axios.get<Dictionary<DropDown[]>>('dictionary/selectList', {
        params: { codes: codes, current: current, filterByRoles: filterByRoles },
    });
    return responce.data;
};

export const getDictionaryItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<DictionaryTable>(`/dictionary/${id}`);
    return data;
};
